<template>
	<div class="fadescaleout" :style="getStyle">
		<template v-if="typeof mode[0] == 'object'">
			<gif :mode="mode[0]"></gif>
		</template>
		<span class="fadescaleout-title">{{title}}</span>
	</div>
</template>

<script>
	export default {
		name: 'fadescaleout',
		props: ['title', 'mode'],
		components: {},
		computed: {
			getStyle () {
				if (this.$util.typeOf(this.mode[0]) == 'string') {
					return {backgroundImage: 'url('+ this.mode[0] +')'};
				} else {
					return {};
				}
			}
		},
		data () {
			return {}
		},
		created () {}
	}
</script>

<style>
	.fadescaleout {
		position: absolute;
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		z-index: 999;
		animation: fadescaleout 6s ease-in-out 1s 1 normal forwards;
		transform-style: preserve-3d;
		opacity: 1;
	}
	@keyframes fadescaleout_title {
		from {
			opacity: 1;
		}
		50% {
			opacity: 1;
		}
		to {
			opacity: 0;
			transform: scale(1.5);
		}
	}
	@keyframes fadescaleout {
		from {
			opacity: 1;
		}
		50% {
			opacity: 1;
		}
		to {
			opacity: 0;
			transform: scale(1.2);
		}
	}
	.fadescaleout-title {
		position: absolute;
		width: 500px;
		height: 500px;
		text-align: center;
		line-height: 500px;
		top: 50%;
		margin-top: -250px;

		display: table-cell;
	    font-size: 30px;
	    font-weight: bold;
	    letter-spacing: 2px;
	    color: #ff60f2;
	    text-shadow: 0 0 3px #ffffff, 0 0 5px #ffffff, 0 0 10px #ffffff, 0 0 15px #ffffff;

	    animation: fadescaleout_title 2s ease-in-out 4s 1 normal forwards;
	}
</style>